export default __webpack_public_path__ + "static/network-3-c539adfe5b9e01b4f5738b5121c30c34.png";